"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10z"
}), 'SouthEastTwoTone');